export const list_skill_group = [
    [
        {
            name: "Graphql",
            score: "Expert"
        },
        {
            name: "Flutter",
            score: "Expert"
        },
        {
            name: "Express",
            score: "Expert"
        },
    ],
    [
        {
            name: "BigchainDb",
            score: "Intermediate"
        },
        {
            name: "PostgreSQL",
            score: "Expert"
        },
        {
            name: "MongoDb",
            score: "Expert"
        },
    ],
    [
        {
            name: "ReactJs",
            score: "Expert"
        },
        {
            name: "NextJs",
            score: "Intermediate"
        },
        {
            name: "NodeJs",
            score: "Expert"
        },
    ],
    [
        {
            name: "TailwindCss",
            score: "Expert"
        },
        {
            name: "AngularJs",
            score: "Lower-Intermediate"
        },
        {
            name: "BootstrapCss",
            score: "Intermediate"
        },
    ],
    [
        {
            name: "MySQL",
            score: "Intermediate"
        },
        {
            name: "VueJs",
            score: "Intermediate"
        },
        {
            name: "Matrix",
            score: "Intermediate"
        },
    ],
]


